import { isPlatformBrowser } from "@angular/common";
import { HttpHeaders } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { CONSTANTS } from "./constants";
declare let $: any;

@Injectable({ providedIn: 'root' })
export class GlobalFunctions {
  constructor(
    private messageService: MessageService,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }


  setDataInLocalStorage(keyName: string, value: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(btoa(keyName), btoa(JSON.stringify(value)));
    }
  }

  getAccessTokenFromLocalStorage(keyName: string): any {
    let tempValue: any;
    if (isPlatformBrowser(this.platformId) && localStorage.getItem(btoa(keyName))) {
      tempValue = JSON.parse(atob(localStorage.getItem(btoa(keyName))!));
    }
    return tempValue;
  }

  removeDataFromLocalStorage(keyName: string) {
    if (isPlatformBrowser(this.platformId) && localStorage.getItem(btoa(keyName))) {
      localStorage.removeItem(btoa(keyName));
    }
  }

  getHeader(): any {
    return {
      headers: new HttpHeaders({
        'content-type': 'application/json'
      }),
    };
  };

  getAuthorizationHeader(): HttpHeaders {
    let headers = new HttpHeaders();
    if (isPlatformBrowser(this.platformId)) {
      headers = headers.set(
        'authorization', 'bearer ' + atob(localStorage.getItem(btoa('accessToken'))!)
      );
    }
    return headers;
  }

  getAuthorizationHeaderForPublicApi(): HttpHeaders {
    let headers = new HttpHeaders();
    if (isPlatformBrowser(this.platformId)) {
      headers = headers.set(
        'authorization', 'bearer ' + atob(localStorage.getItem(btoa('accessToken'))!)
      );
    }
    return headers;
  }

  getUserType() {
    if (isPlatformBrowser(this.platformId)) {
      return atob(localStorage.getItem(btoa('userType'))!);
    }
    return null;
  }

  getUserProfileComplated() {
    if (isPlatformBrowser(this.platformId)) {
      return atob(localStorage.getItem(btoa('userProfileComplated'))!);
    }
    return null;
  }

  successErrorHandling(response: any, that: any, messageVariable: any): any {
    this.messageService.clear();
    let messageText = '';
    messageText = response.Message || response.message || CONSTANTS.message.INTERNAL_ERROR;
    if (response.status === CONSTANTS.errorCodes.UNAUTHORIZED ||
      response.status === CONSTANTS.errorCodes.TOKEN_EXPIRED ||
      response.status === CONSTANTS.errorCodes.BAD_REQUEST ||
      response.status === CONSTANTS.errorCodes.TOKEN_REQUIRED) {
      if (isPlatformBrowser(this.platformId)) {
        localStorage.removeItem('accessToken');
      }
      this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: messageText });
      // window.location.href = '/login';
      this._router.navigate(['/login'], { queryParams: { redirectURL: this._router.url } });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: messageText });
    };
    if (messageVariable) {
      messageVariable = messageText;
    };
  };

  errorHanding(errorResponse: any, that: any, messageVariable: any, isSingleErrorReturn: boolean = false): any {
    const error = errorResponse?.error || errorResponse;
    this.messageService.clear();

    let messageText = '';
    if (typeof errorResponse === 'string') {
      messageText = errorResponse;
    } else if (typeof error === 'string') {
      messageText = error;
    } else if (error?.message) {
      messageText = error.message;
    } else if (error?.Message) {
      messageText = error.Message;
    } else if (error?.detail) {
      messageText = error.detail;
    } else if (typeof error?.error === 'string') {
      messageText = error.error;
    } else if (errorResponse?.message) {
      messageText = errorResponse.message;
    } else if (errorResponse?.Message) {
      messageText = errorResponse.Message;
    } else {
      messageText = CONSTANTS.message.INTERNAL_ERROR;
    }
    if (errorResponse?.status === CONSTANTS.errorCodes.UNAUTHORIZED ||
      errorResponse?.status === CONSTANTS.errorCodes.TOKEN_EXPIRED ||
      errorResponse?.status === CONSTANTS.errorCodes.TOKEN_REQUIRED) {
      if (isPlatformBrowser(this.platformId)) {
        localStorage.removeItem('accessToken');
        this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: messageText });
        this._router.navigate(['/login'], { queryParams: { redirectURL: this._router.url } });
      }
    } else if (errorResponse?.status === CONSTANTS.errorCodes.ERROR_CODE_VALIDATION_FAILED ||
      errorResponse?.status === CONSTANTS.errorCodes.ALREADY_EXISTS) {
      if (error?.error && Object.keys(error.error).length) {
        messageText = '';
        error.error.forEach((message: any, key: any) => {
          messageText = messageText + ' ' + message;
          if (isSingleErrorReturn) {
            if (messageVariable) {
              messageVariable = messageText;
            }
            if (that?.message) that.message.error = messageText;
            $('#' + key).focus();
            return;
          }
        });
        this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: messageText });
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: messageText });
    }
    if (!messageVariable) {
      if (that?.message) {
        that.message.error = messageText;
      }
    } else {
      messageVariable = messageText;
    }
    if (that?.isLoading) {
      that.isLoading = false;
    }
  }

}
